import { components } from 'react-select';
import { FaImage } from 'react-icons/fa';
import styles from 'styles/common/checkbox.module.css';
import { SelectedData } from 'types/common/FormTypes';
import { ImageWithFallback } from 'Components/pos2u/ImageWithFallback';
import { truncateText_v2 } from 'utils/common/String';

export interface CheckboxOptionProps {
  label: string;
  isSelected?: boolean;
  isFocused?: boolean;
  image?: string;
  data: SelectedData;
  selectProps?: any;
}

export const CheckboxOptionWithImg = (props: CheckboxOptionProps) => {
  return (
    <components.Option {...props}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <input
          className={styles.checkbox}
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: '10px' }}
        />
        <div
          style={{
            width: '3rem',
            height: '3rem',
            overflow: 'hidden',
            display: 'inline-block',
            marginRight: '10px',
            transition: 'transform 0.3s ease',
          }}
          className="image-container"
        >
          {props.data.image && props.data.image !== '' ? (
            <ImageWithFallback
              src={props.data.image}
              alt={props.label}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                marginRight: '10px',
              }}
              errImgSize="3rem"
            />
          ) : (
            <FaImage
              style={{ fontSize: '3rem', color: 'gray', marginRight: '10px' }}
            />
          )}
        </div>
        {props.label}
      </div>
    </components.Option>
  );
};

export const CheckboxOption = (props: any) => {
  return (
    <>
      <components.Option {...props}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            className={styles.checkbox}
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{
              marginRight: '10px',
              outline: 'none',
              cursor: 'pointer',
              border: props.isFocused ? '2px solid #fff' : '2px solid #4bb189',
            }}
          />
          {props.label}
        </div>
      </components.Option>
    </>
  );
};
export const CheckboxTagOption = (props: any) => {
  const { data, isSelected, isFocused, label } = props;
  const isNew = data.__isNew__ ? true : false;

  return (
    <>
      <components.Option {...props}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            gap: '8px',
          }}
        >
          <input
            className={styles.checkbox}
            type="checkbox"
            onChange={() => null}
            checked={isSelected}
            style={{
              marginRight: '10px',
              outline: 'none',
              cursor: 'pointer',
              border: isFocused ? '2px solid #fff' : '2px solid #4bb189',
            }}
          />

          <div style={{ flex: 1 }}>{truncateText_v2(label)}</div>

          <span
            className="badge tag-soft-badge"
            style={
              {
                fontSize: '0.75rem',
                whiteSpace: 'normal',
                fontWeight: isFocused ? 'bolder' : '',

                '--color': isFocused
                  ? '#4bb189'
                  : data.color
                  ? data.color
                  : '#4bb189',
                backgroundColor: isFocused ? 'rgb(255, 255, 255)' : '',
                transition: 'all 0.2s ease-in-out',
              } as React.CSSProperties
            }
          >
            {isNew
              ? truncateText_v2(label.replace(/^Create\s+"(.+)"$/, '$1'))
              : truncateText_v2(label)}
          </span>
        </div>
      </components.Option>
    </>
  );
};

export const CompactValueContainer = ({
  children,
  ...props
}: {
  children: React.ReactNode;
  [key: string]: any;
}) => {
  const { getValue } = props;
  const selectedValues = getValue();

  const displayText =
    selectedValues.length > 1
      ? `${selectedValues.length} items selected`
      : selectedValues.map((val: { label: string }) => val.label).join(', ');

  return (
    <components.ValueContainer {...props}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap',
        }}
        title={displayText}
      >
        {children}
      </div>
    </components.ValueContainer>
  );
};
